// This is generated.  Alter it in blockGroups/actionElements/types/ImportForm.js
/* eslint-disable no-unused-vars */
const { merge } = require('lodash');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context,
    parentAccessRestrictions,
  ) {
    const { children } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    if (accessRestrictions.hidden) return [{}, {}];

    let [_subDataDictionary = {}, _partialTypeDefinition = {}] =
      children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context, accessRestrictions);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // View-only block: only pass through child subDataDictionary contributions.
    // Do NOT create or merge into the canonical [namespace][relation] slot.
    // Import forms have their own validation context separate from canonical create/update.
    return [_subDataDictionary, _partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'actionElements',
  'ImportForm',
  module.exports,
);
